import { billingCycleDependBasePlanTypeList, dependMeetingPlanTypeList, planTypes } from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from "@/common/service/default-mapper";
import Store from '@/store';

const TranslationKey = [
    'translation_captions',
]

export default (planMapJSON) => {
    const enableTranslation = Store.getters.enableTranslation;
    return enableTranslation ? TranslationKey.reduce((pre, key) => {
        return [
            ...defaultMapper(planMapJSON[key], planTypes.TRANSLATION_CAPTIONS).map(item => ({
                ...item,
                capacity: planMapJSON[key].participants,
                participants: planMapJSON[key].participants,
                typeNameKey: 'billing.translation_caption.title',
                planNameKey: 'billing.translation_caption.title',
                dependBasePlanTypeList: dependMeetingPlanTypeList,
                billingCycleDependBasePlanTypeList,
                unit: planUnitMap.license,
            })),
            ...pre,
        ]
    }, []) : null;
}
